// @flow

import * as React from 'react';

import { Base } from '@gandi/ui';

import styles from './ResponsiveDivider.scss';

export type Props = {
  children: React.Node,
  ...
};

function Divider({ children }: Props) {
  return (
    <Base flex flexGrow1 className={styles.root}>
      {children}
    </Base>
  );
}

export default (React.memo<Props>(Divider): React.ComponentType<Props>);
